import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  margin: 2rem auto;
  padding: 0 1rem;
  display: grid;
  grid-template-columns: 256px 1fr;
  gap: 2rem;
  align-items: flex-start;
  display: flex;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr;
  }
`;
